import React, { useRef, useState, useEffect } from "react";
import "./youtubeEmbed.scss";
import { PlayIcon } from "../../assets/Icons";
import { useWindowSize } from "react-use";

const YoutubeEmbed = ({
  videoId,
  thumbnail,
  mobileThumbnail,
  iconcss,
  iframecss,
  isHoveredIndex,
  setIsHoveredIndex,
}) => {
  const { width } = useWindowSize();
  // const [isHovered, setIsHovered] = useState(false);
  const [shouldPlay, setShouldPlay] = useState(false);
  const containerRef = useRef(null);
  const timerRef = useRef(null);
  const isMobile = width <= 992;

  useEffect(() => {
    if (isMobile) {
      const handleScroll = () => {
        const rect = containerRef.current.getBoundingClientRect();
        const center = window.innerHeight / 2;
        const distanceFromCenter = Math.abs(
          rect.top + rect.height / 2 - center
        );

        if (distanceFromCenter < rect.height / 2) {
          // close to center
          clearTimeout(timerRef.current);
          timerRef.current = setTimeout(() => {
            setShouldPlay(true);
          }, 1000);
        } else {
          clearTimeout(timerRef.current);
          setShouldPlay(false);
        }
      };

      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleScroll);
      handleScroll(); // initial run

      return () => {
        window.removeEventListener("scroll", handleScroll);
        window.removeEventListener("resize", handleScroll);
        clearTimeout(timerRef.current);
      };
    }
  }, [isMobile]);

  const youtubeFrame = () => (
    <iframe
      className={`block ${iframecss}`}
      src={`https://www.youtube.com/embed/${videoId}?playlist=${videoId}&rel=0&autoplay=1&mute=1&loop=1&controls=0`}
      title="YouTube video"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullScreen
      style={{ pointerEvents: "none" }}
    />
  );

  return (
    <div
      className="w-full h-full relative bg-glass backdrop-blur-3xl"
      onMouseEnter={() => !isMobile && setIsHoveredIndex(videoId)}
      onMouseLeave={() => !isMobile && setIsHoveredIndex(null)}
      ref={containerRef}
    >
      {isMobile ? (
        shouldPlay ? (
          youtubeFrame()
        ) : (
          <div className="h-full w-full cursor-pointer relative">
            <img
              src={isMobile && mobileThumbnail ? mobileThumbnail : thumbnail}
              alt="Youtube Thumbnail"
              className="h-full w-full object-cover object-center"
            />
            <img
              src={PlayIcon}
              alt="Play Icon"
              className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${iconcss}`}
            />
          </div>
        )
      ) : isHoveredIndex === videoId ? (
        youtubeFrame()
      ) : (
        <div className="h-full w-full cursor-pointer relative">
          <img
            src={isMobile && mobileThumbnail ? mobileThumbnail : thumbnail}
            alt="Youtube Thumbnail"
            className="h-full w-full object-cover"
          />
          <img
            src={PlayIcon}
            alt="Play Icon"
            className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${iconcss}`}
          />
        </div>
      )}
    </div>
  );
};

export default YoutubeEmbed;
